<template lang="html">
  <div class="list-item">
    <b-checkbox v-model="ingredientItem.selected" v-if="selectable && !ingredientItem.saved">
      {{ amount }}<span class="unit" v-if="unit">{{ unit }}</span>
      {{ name }}
    </b-checkbox>

    <div v-else-if="selectable && ingredientItem.saved">
      <b-icon icon="check" type="is-success"/> {{ amount }}<span class="unit" v-if="unit">{{ unit }}</span>
      {{ name }}
    </div>


    <a :href="wikiArticleUrl" v-else-if="wikiArticleUrl">
      {{ amount }}<span class="unit" v-if="unit">{{ unit }}</span>
      {{ name }}
    </a>
    <span v-else>
      {{ amount }}<span class="unit" v-if="unit">{{ unit }}</span>
      {{ name }}
    </span>

    <a :href="affiliateUrl" target="_blank" v-if="affiliateUrl">
      <b-icon icon="amazon" type="is-amazon"/>
    </a>
  </div>
</template>

<script>
import format from 'shared/lib/format'

export default {
  props: {
    ingredientItem: {type: Object, required: true},
    orginalServingCount: {type: Number, default: 1},
    currentServingCount: {type: Number, default: 1},
    selectable: {type: Boolean, default: false}
  },

  computed: {
    wikiArticleUrl(){
      if(!this.ingredientItem.ingredient || !this.ingredientItem.ingredient.wiki_article) return
      return this.ingredientItem.ingredient.wiki_article.url
    },

    name(){
      return format.ingredientName(this.ingredientItem, this.currentServingCount / this.orginalServingCount)
    },

    amount(){
      if(this.currentServingCount > 0) return format.ingredientAmount(this.ingredientItem, this.currentServingCount / this.orginalServingCount)
      return format.ingredientAmount(this.ingredientItem)
    },

    unit(){
      if(this.currentServingCount > 0) return format.ingredientUnit(this.ingredientItem, this.currentServingCount / this.orginalServingCount)
      return format.ingredientUnit(this.ingredientItem)
    },

    affiliateUrl(){
      if(this.ingredientItem.ingredient){
        return this.ingredientItem.ingredient.affiliate_url
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/ingredients/Item.vue